import { useTranslation } from 'react-i18next';

const ErrorBanner = ({
  showBanner,
  errorCode,
  message,
  onCloseHandle,
  customClass = '',
  bannerCloseTimer,
}) => {
  const { t } = useTranslation('translation');
  const bannerText = message || t(errorCode);

  if (bannerCloseTimer) {
    setTimeout(onCloseHandle, bannerCloseTimer * 1000);
  }

  return (
    showBanner && (
      <div
        className={
          'flex justify-between items-center py-2 px-2 sm:px-5 lg:-mx-5 md:-mx-4 sm:-mx-3 -mx-3 error-banner ' +
          customClass
        }
        id="error-banner"
      >
        <div
          className="error-banner-text text-sm font-semibold"
          id="error-banner-message"
        >
          {bannerText}
        </div>
        <button
          onClick={onCloseHandle}
          onKeyDown={onCloseHandle}
          id="error-close-button"
        >
          <img
            className="h-2.5 w-2.5 hover:cursor-pointer"
            src="images/cross_icon.svg"
            alt="close"
          />
        </button>
      </div>
    )
  );
};

export default ErrorBanner;
